export default __webpack_public_path__ + "static/media/ori.pouza.676f85c2.jpg";